import React from 'react';
import PropTypes from 'prop-types';
import Verify from '~images/icons/verify';
import styles from './name.module.scss';

export default function Name({ className = '', name, icon = <Verify />, pronouns = '' }) {
  return (
    <div className={styles.title}>
      <h1 className={`${className || ''} ${styles?.name || ''}`}>
        {name}
        {pronouns && <small>({pronouns})</small>}
      </h1>
      {icon}
    </div>
  );
}

Name.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.element,
  pronouns: PropTypes.string,
};
